import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@24.10.7_@vue+compiler-sfc@3.5.13_cac@6.7.1_b9b3c333d7db46a7ef4be30188054340/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}